import { CurrencyPipe, DATE_PIPE_DEFAULT_OPTIONS, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  inject,
  isDevMode,
  provideAppInitializer,
  type ApplicationConfig,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { getTheme } from './shared/helpers/theme.helpers';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { httpErrorInterceptor } from './shared/interceptors/http-error.interceptor';
import { OpaCurrencyPipe } from './shared/pipes/opa-currency.pipe';
import { AuthService } from './shared/services/auth.service';
import { TranslocoHttpLoader } from './shared/services/transloco.loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideOAuthClient(),
    provideAppInitializer(() => inject(AuthService).initialize$()),
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd.MM.yyyy.' } },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    DatePipe,
    CurrencyPipe,
    OpaCurrencyPipe,
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['en-GB'],
        defaultLang: 'en-GB',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    importProvidersFrom(PorscheDesignSystemModule.load({ theme: getTheme() })),
  ],
};
